import { sdk } from '@/lib/api';
import { FetchError } from '@/lib/api/client';
import { queryKeysFactory } from '@/lib/query-key-factory';
import { HttpTypes } from '@/types';
import { QueryKey, UseQueryOptions, useQuery } from '@tanstack/react-query';
import Cookies from 'js-cookie';

const PRODUCT_QUERY_KEY = 'product-list' as const;
const PRODUCT_CATEGORY_QUERY_KEY = 'product-category' as const;
const COLLECTION_QUERY_KEY = 'collection-list' as const;

export const collectionsQueryKeys = queryKeysFactory(COLLECTION_QUERY_KEY);
export const productCategoryQueryKeys = queryKeysFactory(PRODUCT_CATEGORY_QUERY_KEY);
export const productsQueryKeys = queryKeysFactory(PRODUCT_QUERY_KEY);

export const useProductCollections = (
  query: HttpTypes.FindParams,
  token?: string,
  options?: Omit<
    UseQueryOptions<
      HttpTypes.StoreProductListResponse,
      FetchError,
      HttpTypes.StoreProductListResponse,
      QueryKey
    >,
    'queryFn' | 'queryKey'
  >
) => {
  const locationId = Cookies.get('_location_id');

  const { data, ...rest } = useQuery({
    queryKey: collectionsQueryKeys.list(query),
    queryFn: async () =>
      query.slug === 'all'
        ? sdk.site.homepage.retrieveAllProducts(query, token as string, locationId)
        : sdk.site.homepage.retrieveProducts(query, token as string, locationId),
    ...options,
  });

  return { data, ...rest };
};

export const useProductCategory = (
  query: HttpTypes.FindParams,
  options?: Omit<
    UseQueryOptions<
      HttpTypes.StoreProductCategoryResponse,
      FetchError,
      HttpTypes.StoreProductCategoryResponse,
      QueryKey
    >,
    'queryFn' | 'queryKey'
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: productCategoryQueryKeys.list(query),
    queryFn: async () => sdk.site.homepage.categoryList(query),
    ...options,
  });

  return { data, ...rest };
};
